const checkExpires = timestamp => {
  return Date.now() > timestamp;
};

export default checkExpires;
